import { useAtom, useAtomValue } from "jotai";
import { toggleKnownLemmaAction } from "~/server/actions/lemmas-users/actions";
import {
  isLemmaTrackedAtom,
  trackedLemmaIdsAtom,
  trackedLemmasCountAtom,
} from "~/state/lemmas/state";

export function useTrackLemmas() {
  const [trackedLemmaIds, setTrackedLemmaIds] = useAtom(trackedLemmaIdsAtom);
  const [trackedLemmasCount, setTrackedLemmasCount] = useAtom(
    trackedLemmasCountAtom,
  );
  const isLemmaTracked = useAtomValue(isLemmaTrackedAtom);

  const toggleTrackedLemma = async (lemmaId: number) => {
    // Optimistic update
    const isCurrentlyKnown = trackedLemmaIds.includes(lemmaId);
    const newIds = isCurrentlyKnown
      ? trackedLemmaIds.filter((id) => id !== lemmaId)
      : [...trackedLemmaIds, lemmaId];

    setTrackedLemmaIds(newIds);
    setTrackedLemmasCount((prev) => prev + (isCurrentlyKnown ? -1 : 1));

    try {
      const formData = new FormData();
      formData.append("lemmaId", lemmaId.toString());
      await toggleKnownLemmaAction(formData);
    } catch (error) {
      setTrackedLemmaIds(trackedLemmaIds);
      setTrackedLemmasCount(trackedLemmasCount);
      throw error;
    }
  };

  return {
    trackedLemmaIds,
    trackedLemmasCount,
    isLemmaTracked,
    toggleTrackedLemma,
  };
}
